import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { Layout, PageHeading } from '@kira/checkpoint-shared-frontend';
import React from 'react';

import AsyncAssessmentIcon from 'assets/AsyncAssessmentIcon';
import LiveInterviewIcon from 'assets/PracticeInterviewIcon';
import AssessmentTypeCard from 'components/CreateAssessment/AssessmentTypeCard';
import { API_URL } from 'config/app.endpoints';
import { t } from 'locales/i18n';

const SelectAssessmentType = () => (
  <Layout layoutClassName="!bg-kira-blue-50">
    <a
      href={API_URL}
      className="prose-button-lg absolute left-5 top-3.5 flex w-fit items-center bg-transparent p-0 !text-kira-blue-800"
    >
      <ArrowLeftIcon className="mr-1 inline-block h-4 w-4" />
      {t('Back')}
    </a>
    <div className="mx-auto grid h-full w-full !bg-kira-blue-50">
      <div className="place-self-center text-center lg:w-4/5">
        <PageHeading
          primaryText={t('Select an assessment')}
          secondaryText={t('1 OF 2')}
          primaryTextClassName="!prose-display-1 !text-kira-slate-900"
          secondaryTextClassName="!prose-body-lg-reg !text-kira-slate-900"
        />
        <div className="mt-6 flex flex-col justify-center gap-12 lg:flex-row">
          <AssessmentTypeCard
            title={t('Async Assessment')}
            bodyText={t(
              'Create custom asynchronous assessments for all applicants.'
            )}
            icon={<AsyncAssessmentIcon className="mx-auto" />}
            linkUrl="create-assessment"
            dataTestId="async-assessment-card"
          />
          <AssessmentTypeCard
            title={t('Practice')}
            bodyText={t(
              'Create custom async practice for applicants to help them prepare.'
            )}
            icon={<LiveInterviewIcon className="mx-auto" />}
            linkUrl="create-practice"
            dataTestId="practice-card"
          />
        </div>
      </div>
    </div>
  </Layout>
);

export default SelectAssessmentType;
